import styled from "styled-components";
import {DECOUPE_DIM_NAME, SIZE_DIM_NAME} from "../../helper/constants";
import {isDeg} from "../../helper/function";

const Wrapper = styled.div`
    font-weight: bold;
    font-size: 18px;
    color: #144344;
    display: flex;
    flex-direction: row;
    align-items: start;
    justify-content: start;
    padding-top: 20px;
`;
const SizeDimension = styled.div`
    padding: 0 20px 0 0;
    border-right: 1px solid #E4E4F4;
    display: flex;
    flex-direction: column;
`;
const DecoupeDimension = styled.div`
    padding: 0 20px;
    display: flex;
    flex-direction: column;
`;

const Item = styled.div`
`;
export default function DimensionView({dimension}) {

    const getSizeDimensionList = () => {
        let sizeList = [];
        Object.keys(dimension).map(item => {
           if (SIZE_DIM_NAME.includes(item)) {
               sizeList.push({
                   name: item,
                   value: dimension[item]
               });
           }
        });
        return sizeList;
    }

    const getDecoupeDimensionList = () => {
        let sizeList = [];
        Object.keys(dimension).map(item => {
            if (DECOUPE_DIM_NAME.includes(item)) {
                sizeList.push({
                    name: item,
                    value: dimension[item]
                });
            }
        });
        return sizeList;
    }
    return (
        <Wrapper>
            <SizeDimension>
                {getSizeDimensionList().map(dim => (
                    <Item>{`${dim.name} = ${dim.value}`} mm</Item>
                ))}
            </SizeDimension>
            <DecoupeDimension>
                {getDecoupeDimensionList().map(dim => (
                    <Item>{`${dim.name} = ${dim.value}`} {isDeg(dim.name) ? " °" : " mm"} </Item>
                ))}
            </DecoupeDimension>
        </Wrapper>
    );
}